
















































































































































































import AbpBase from "@/lib/abpbase";
import { Component, Prop, Watch } from "vue-property-decorator";
import { CommonUserComponents, LayoutComponents } from "./componentsConfig";
import draggable from "vuedraggable";
import util from "@/lib/util";
import widgetForm from "./widgetForm.vue";
import formConfig from "./formConfig.vue";
import widgetConfig from "./widgetConfig.vue";
import dialogForm from "./dialogForm.vue";
import formsDemo from "./formDemos/index.vue";
import { InsertAssessResult } from "../../api/assessForm";

@Component({
  components: {
    draggable,
    widgetForm,
    formConfig,
    widgetConfig,
    dialogForm,
    formsDemo,
  },
})
export default class extends AbpBase {
  @Prop() data: any;
  CommonUserComponents: any = CommonUserComponents;
  LayoutComponents: any = LayoutComponents;

  @Watch("data", { immediate: true })
  handleFormDataChange() {
    this.configFormData = this.data;
  }

  dragModel: any = {
    group: {
      name: "people",
      pull: "clone",
      put: false,
    },
    sort: false,
    ghostClass: "ghostClass",
  };

  configFormData: any = {
    list: [],
    config: {
      name: "",
      labelWidth: 100,
      labelPosition: "right",
      size: "default",
    },
  };

  widgetFormSelect: any = {
    key: null,
    placeholder: null,
  };

  // 预览弹框是否显示
  dialogVisible = false;
  // 生成json弹框
  jsonDialog = false;
  // 生成的json语句
  jsonmsg = "";
  // 弹框标题
  dialogTitle = "生成JSON";
  // 右侧头部标签栏
  activeName = "first";
  // 弹出文本域是否可编辑,默认不可编辑
  jsonTextareaReadonly = true;
  // 示例弹窗
  demoDialog = false;

  onMove() {
    return true;
  }

  save() {
    // 处理checkbox的defaultValue字段
    let resultData = util.copy(this.configFormData);
    resultData.list.forEach((item) => {
      if (item.type == "checkbox") {
        if (item.defaultValue) {
          item.defaultValue = item.defaultValue.join(",");
        }
      } else {
        if (item.type == "grid") {
          item.columns.forEach((col) => {
            col.list.forEach((citem) => {
              if (citem.type == "checkbox" && citem.defaultValue) {
                citem.defaultValue = citem.defaultValue.join(",");
              }
            });
          });
        }
      }
    });
    this.$emit("on-save", resultData);
  }

  // 保存方法
  saveWidetConfit() {
    this.dialogTitle = "生成JSON";
    this.jsonTextareaReadonly = true;
    this.jsonDialog = true;
    this.jsonmsg = JSON.stringify(this.configFormData, null, 1);
  }

  // 清空方法
  clearWidetConfit() {
    this.configFormData = {
      list: [],
      config: {
        name: "",
        labelWidth: 100,
        labelPosition: "right",
        size: "small",
      },
    };
    this.widgetFormSelect = {
      key: null,
      placeholder: null,
    };
  }

  // 点击预览方法
  showDialog() {
    if (this.configFormData.list.length === 0) {
      this.$Message.error("请先拖拽组件");
      return;
    }
    // 弹出预览框
    this.dialogVisible = true;
    // 异步调用弹框的方法
    setTimeout(() => {
      // 异步调用弹框中的方法传递表单数据
      (this.$refs.dialogForm as any).setFormVal(util.copy(this.configFormData));
    });
  }

  // 读取预览表单的数据
  getDialogForm() {
    // 读取表单生成器中的getFormVal方法获取表单填写的数据
    (this.$refs.dialogForm as any).getFormVal().then((data) => {
      this.dialogTitle = "表单数据";
      this.jsonTextareaReadonly = true;
      this.jsonDialog = true;
      this.jsonmsg = JSON.stringify(data, null, 1);
    });
  }

  // 存储表单数据
  async testInsertAssessResult() {
    if (!this.configFormData.config.id) {
      this.$Message.error("请先保存表单配置");
      return;
    }
    (this.$refs.dialogForm as any).getFormVal().then(async (data) => {
      let json = JSON.stringify(data, null, 1);
      let payload = {
        formId: this.configFormData.config.id,
        resultJson: json,
        //其他数据根据实际需求自行添加
      };
      let res = await InsertAssessResult(payload);
      if (res.code === 2000) {
        this.$Message.info("保存成功");
      }
    });
  }

  // 点击示例DEMO按钮
  hrefDemo() {
    this.demoDialog = true;
  }

  // 导入json方法
  setFormJson() {
    this.dialogTitle = "导入JSON";
    this.jsonTextareaReadonly = false;
    this.jsonDialog = true;
    this.jsonmsg = JSON.stringify(
      {
        list: [],
        config: {
          labelWidth: 100,
          labelPosition: "right",
          size: "small",
        },
      },
      null,
      1
    );
  }

  // 确定导入json
  setJsonBtn() {
    try {
      this.initJson(this.jsonmsg);
      this.jsonDialog = false;
    } catch (error) {
      this.$Message.error("导入JSON有误");
    }
  }

  // 初始化json，接收表单json数据，根据json数据自动渲染表单页面
  initJson(strJson) {
    this.configFormData = JSON.parse(strJson);
    this.widgetFormSelect = this.configFormData.list[0];
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/formBuilder/index.vue